<template>
  <span class="echarts-line">
    <div :id="eid"></div>
  </span>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    props: {
      eid: {
        type: String
      },
      data: {
        xLabel: [],
        xValue: []
      },
      color: {
        type: String,
        default: '#19a3df'
      }
    },
    data() {
      return {
        demoData: {
          xLabel: ['00:01:00', '00:02:00', '00:03:00', '00:04:00', '00:05:00', '00:06:00', '00:07:00', '00:08:00',
            '00:09:00', '00:10:00', '00:11:00', '00:12:00'
          ],
          xValue: [{
              time: '00:01:00',
              data: '0'
            },
            {
              time: '00:02:00',
              data: '0'
            },
            {
              time: '00:03:00',
              data: '0'
            },
            {
              time: '00:04:00',
              data: '0'
            },
            {
              time: '00:05:00',
              data: '0'
            },
            {
              time: '00:06:00',
              data: '0'
            },
            {
              time: '00:07:00',
              data: '0'
            },
            {
              time: '00:08:00',
              data: '0'
            },
            {
              time: '00:09:00',
              data: '0'
            },
            {
              time: '00:10:00',
              data: '0'
            },
            {
              time: '00:11:00',
              data: '0'
            },
            {
              time: '00:12:00',
              data: '0'
            }
          ]
        }
      };
    },
    methods: {
      init() {
        let op = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: '#19cae4',
            padding: 5,
            borderColor: '#19cae4',
            extraCssText: 'width:auto;height:auto;color:#fff',
            textStyle: {
              color: '#fff'
            },
            axisPointer: {
              lineStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                      offset: 0,
                      color: 'rgba(255,255,255,0)' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: 'rgba(255,255,255,1)' // 100% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(255,255,255,0)' // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          },
          grid: {
            top: '18%',
            left: '12%',
            right: '4%',
            bottom: '25%'
            // containLabel: true
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: false,
              lineStyle: {
                color: 'rgba(23,88,148,0.4)'
              }
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
                color: '#08265F',
                padding: 10,
                fontSize: 10,
              rotate: 40,
              formatter: function(data) {
                return data;
              },
              showMinLabel: true,
              showMaxLabel: true
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(23,88,148,0.4)'
              }
            },
            axisTick: {
              show: false
            },
            data: this.data.xLabel && this.data.xLabel.length > 0 ? this.data.xLabel : this.demoData.xLabel
          }],
          yAxis: [{
            name: '功率(kW)',
            type: 'value',
            nameTextStyle: {
              color: '#08265F',
              fontSize: 12,
              padding: [12, 0, 0, 0]
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(39, 198, 255, 0.1)',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(23,88,148,0.4)'
              }
            },
            axisLabel: {
              show: true,
                color: '#08265F',
                fontSize: 10,
                padding: [0, 5, 0, 0],
              formatter: function(value) {
                if (value === 0) {
                  return value;
                }
                return value;
              }
            },
            axisTick: {
              show: false
            }
          }],
          series: [{
            name: '功率',
            type: 'line',
            smooth: true,
            showSymbol: true,
            symbolSize: 8,
            zlevel: 3,
            itemStyle: {
              color: this.color,
              borderColor: '#a3c8d8'
            },
            lineStyle: {
              width: 2,
              color: this.color
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [{
                    offset: 0,
                    color: this.hex2rgba(this.color, 0.4)
                  },
                  {
                    offset: 0.8,
                    color: this.hex2rgba(this.color, 0.1)
                  }
                ],
                false
              )
            },
            data: this.data.xValue && this.data.xValue.length > 0 ? this.data.xValue : this.demoData.xValue
          }]
        };
        this.options = op;
        return op;
      },
      hex2rgba(a, o) {
        if (a == '') {
          return '';
        }
        a = a.substring(1);
        a = a.toLowerCase();
        let b = new Array();
        for (let x = 0; x < 3; x++) {
          b[0] = a.substr(x * 2, 2);
          b[3] = '0123456789abcdef';
          b[1] = b[0].substr(0, 1);
          b[2] = b[0].substr(1, 1);
          b[20 + x] = b[3].indexOf(b[1]) * 16 + b[3].indexOf(b[2]);
        }
        let res = 'rgba(' + b[20] + ',' + b[21] + ',' + b[22] + ',' + o + ')';
        return res;
      },
      reset() {
        this.$nextTick(function() {
          let ct = echarts.getInstanceByDom(document.getElementById(this.eid));
          if (ct == undefined) {
            ct = echarts.init(document.getElementById(this.eid));
          }
          this.myChart = ct;
          let tmp = this.init();
          if (tmp) {
            ct.setOption(tmp);
          } else {
            console.log('数据问题chargingStatistics');
          }
        });
      }
    },
    mounted() {
      this.reset();
      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize();
        }
      });
    }
  };
</script>

<style lang="scss">
  .echarts-line {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: inline-block;

    div {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/echarts-line.vue